/**
 * Valores da propriedade `tipo_atendimento` do evento Mixpanel `Novo_Agendamento`.
 * Indica se o agendamento vem de um pacote ativo ou não.
 */
export const TIPO_ATENDIMENTO = Object.freeze({
	SESSAO_DE_PACOTE: "sessao de pacote",
	INDIVIDUAL: "individual",
});
